import React, { useContext, useState } from 'react'
import { DataContext } from '../store/GlobalState'
import Beneficiaire from '../Services/Beneficiaire'
import { toast } from 'react-toastify'
import { getDataByID } from '../utils/fetchData'

const DeleteBeneficiaireModal = () => {
  const { state, dispatch } = useContext(DataContext)
  const [isLoading, setIsLoading] = useState(false)

  const { auth, beneficiaire } = state
  const requestConfig = {
    headers: {
      Authorization: `Bearer ${auth?.token}`,
    },
  }
  const handleDelete = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    var beneficiaireRequest = Beneficiaire.deleteBeneficiaire(
      beneficiaire.id,
      requestConfig
    );
    await beneficiaireRequest
      .then(() => {
        setIsLoading(false);
        if (!auth?.user?.admin_type) {
          getDataByID("beneficiairebyemploye", auth?.user?.id, auth.token)
            .then((res) => {
              console.log("res benef", res);
              dispatch({
                type: "LIST_BENEFICIAIRE_BY_ENTREPRISE",
                payload: res.sort((a, b) => b?.id - a?.id),
              });
            })
            .catch((e) => {
              console.log("e", e);
            });
        } else {
          getDataByID("beneficiairebyemploye", auth?.user?.parent, auth.token)
            .then((res) => {
              console.log("res benef", res);
              dispatch({
                type: "LIST_BENEFICIAIRE_BY_ENTREPRISE",
                payload: res.sort((a, b) => b?.id - a?.id),
              });
            })
            .catch((e) => {
              console.log("e", e);
            });
        }
        window.$(".delete-beneficiaire-modal").modal("hide");
        dispatch({ type: "SHOW_BENEFICIAIRE", payload: {} });
        toast.success("Participant(e) archivé(e) !");
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
        toast.error("Oupss! Une erreur est survenue lors de la suppréssion.");
      });
  };
  return (
    <div className="modal-dialog easypm-modal-dialog modal-md">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5
            className="modal-title easypm-modal-title"
            id="DeletingFamilyModal"
          >
            Suppression d'un(e) participant(e)
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => dispatch({ type: "EDIT_BENEFICIAIRE", payload: {} })}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="deleting-family-form-container">
            <div className="alert-delete-message">
              <span>
                Êtes vous sûr de vouloir archiver cet(te) participant(e) ?
              </span>
            </div>

            <div className="row delete-row">
              <div className="col-md-10 offset-md-2 crud-form-action-btn-container">
                <button
                  onClick={() =>
                    dispatch({
                      type: "SHOW_BENEFICIAIRE",
                      payload: {},
                    })
                  }
                  className="btn btn-default cancelleb-btn delete-actions"
                  data-dismiss="modal"
                >
                  Retour
                </button>
                {!isLoading ? (
                  <button
                    className="btn btn-primary crud-submit-btn delete-actions"
                    onClick={handleDelete}
                  >
                    Valider
                  </button>
                ) : (
                  <button className="btn btn-primary crud-submit-btn delete-actions">
                    En cours &nbsp;
                    <i className="fas fa-spin fa-spinner"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteBeneficiaireModal
